import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../context/AuthContext';
import { useWishlist } from '../context/WishlistContext';
import ProductCard from '../components/ProductCard';

export default function Wishlist() {
  const { user } = useAuth();
  const { ids } = useWishlist();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { navigate('/login'); return; }
    api.get('/wishlist').then(r => setProducts(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [user, ids]); // re-fetch when wishlist changes

  if (loading) return <div className="spinner" />;

  return (
    <div className="container">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800 }}>
          My Wishlist {products.length > 0 && <span style={{ fontSize: 16, color: '#6b7280', fontWeight: 400 }}>({products.length} items)</span>}
        </h1>
        <Link to="/shop" className="btn btn-outline btn-sm">Continue Shopping</Link>
      </div>

      {products.length === 0 ? (
        <div className="empty-state">
          <div className="icon">&#9825;</div>
          <h3>Your wishlist is empty</h3>
          <p>Save products you love by clicking the heart icon.</p>
          <Link to="/shop" className="btn btn-primary" style={{ marginTop: 16 }}>Browse Products</Link>
        </div>
      ) : (
        <div className="products-grid">
          {products.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
